import React, { useState, useMemo } from 'react';

function ProductPicker({ products, currentSlot, onAssign, onClear, onClose }) {
  const [search, setSearch] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(currentSlot?.product || null);
  const [quantite, setQuantite] = useState(currentSlot?.quantite || 1);
  const [categoryFilter, setCategoryFilter] = useState('');

  const categories = useMemo(() => [...new Set(products.map(p => p.categorie))], [products]);

  const filtered = useMemo(() => {
    return products.filter(p => {
      const matchSearch = !search ||
        p.nom.toLowerCase().includes(search.toLowerCase()) ||
        p.reference.toLowerCase().includes(search.toLowerCase());
      const matchCat = !categoryFilter || p.categorie === categoryFilter;
      return matchSearch && matchCat;
    });
  }, [products, search, categoryFilter]);

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)', zIndex: 2000,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }} onClick={onClose}>
      <div style={{
        background: '#fff', borderRadius: '16px', width: '550px', maxHeight: '80vh',
        overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
        display: 'flex', flexDirection: 'column',
      }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{
          padding: '16px 20px', borderBottom: '1px solid #eee',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
          <h3 style={{ margin: 0, fontSize: '16px', color: '#333' }}>
            Choisir un produit
          </h3>
          <button onClick={onClose} style={{
            background: '#f5f5f5', border: 'none', borderRadius: '50%',
            width: '30px', height: '30px', fontSize: '16px', cursor: 'pointer', color: '#666',
          }}>&times;</button>
        </div>

        {/* Recherche + filtre */}
        <div style={{ padding: '12px 20px', borderBottom: '1px solid #eee', display: 'flex', gap: '8px' }}>
          <input
            type="text"
            placeholder="Rechercher..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{
              flex: 1, padding: '8px 14px', border: '1px solid #ddd', borderRadius: '8px',
              fontSize: '13px', outline: 'none',
            }}
          />
          <select
            value={categoryFilter}
            onChange={e => setCategoryFilter(e.target.value)}
            style={{
              padding: '8px 10px', border: '1px solid #ddd', borderRadius: '8px',
              fontSize: '13px', background: '#fff', cursor: 'pointer',
            }}
          >
            <option value="">Toutes</option>
            {categories.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>

        {/* Liste produits */}
        <div style={{ flex: 1, overflow: 'auto', padding: '8px 12px', maxHeight: '350px' }}>
          {filtered.map(product => {
            const isSelected = selectedProduct?.id === product.id;
            return (
              <div
                key={product.id}
                onClick={() => setSelectedProduct(product)}
                style={{
                  display: 'flex', alignItems: 'center', gap: '10px',
                  padding: '8px 12px', borderRadius: '8px', cursor: 'pointer',
                  marginBottom: '2px',
                  background: isSelected ? '#e3f2fd' : 'transparent',
                  border: isSelected ? '1px solid #1565c0' : '1px solid transparent',
                  transition: 'all 0.1s',
                }}
                onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = '#f5f5f5'; }}
                onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = 'transparent'; }}
              >
                {/* Couleur */}
                <div style={{
                  width: '24px', height: '24px', borderRadius: '6px',
                  background: product.couleur, border: '1px solid #00000015',
                  flexShrink: 0,
                }} />

                {/* Info */}
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#333' }}>
                    {product.nom}
                  </div>
                  <div style={{ fontSize: '11px', color: '#999' }}>
                    {product.reference} - {product.categorie} - {product.type}
                  </div>
                </div>

                {/* Prix */}
                <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#1565c0' }}>
                  {product.prix.toFixed(2)} CHF
                </div>

                {/* Stock dispo */}
                <div style={{
                  fontSize: '11px', color: '#666', background: '#f5f5f5',
                  padding: '2px 8px', borderRadius: '10px',
                }}>
                  Stock: {product.stock_actuel}
                </div>
              </div>
            );
          })}
        </div>

        {/* Bas : quantite + boutons */}
        <div style={{
          padding: '14px 20px', borderTop: '1px solid #eee',
          display: 'flex', alignItems: 'center', gap: '12px',
        }}>
          {selectedProduct && (
            <>
              <div style={{
                width: '20px', height: '20px', borderRadius: '4px',
                background: selectedProduct.couleur,
              }} />
              <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#333', flex: 1 }}>
                {selectedProduct.nom}
              </span>
            </>
          )}
          {!selectedProduct && (
            <span style={{ fontSize: '13px', color: '#999', flex: 1 }}>Selectionnez un produit</span>
          )}

          <label style={{ fontSize: '12px', color: '#666' }}>Qte:</label>
          <input
            type="number"
            min={1}
            max={99}
            value={quantite}
            onChange={e => setQuantite(Math.max(1, parseInt(e.target.value) || 1))}
            style={{
              width: '60px', padding: '6px 10px', border: '1px solid #ddd',
              borderRadius: '6px', fontSize: '14px', textAlign: 'center',
            }}
          />

          {currentSlot && (
            <button onClick={onClear} style={{
              padding: '8px 14px', background: '#fff', color: '#c62828',
              border: '1px solid #c62828', borderRadius: '8px', fontSize: '13px',
              cursor: 'pointer', fontWeight: 'bold',
            }}>
              Vider
            </button>
          )}

          <button
            onClick={() => selectedProduct && onAssign(selectedProduct, quantite)}
            disabled={!selectedProduct}
            style={{
              padding: '8px 20px',
              background: selectedProduct ? '#1565c0' : '#ccc',
              color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px',
              cursor: selectedProduct ? 'pointer' : 'default', fontWeight: 'bold',
            }}
          >
            Affecter
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductPicker;
